import React from "react";
import { uploadImage } from "../lib/api";
import { mediaUrl } from "../lib/format";
import { toast } from "sonner";
import { ArrowUp, ArrowDown, Trash2, Type, AlignLeft, Image as ImageIcon, Code } from "lucide-react";

const TYPES = [
  { type: "heading", label: "Título", icon: Type },
  { type: "text", label: "Texto", icon: AlignLeft },
  { type: "image", label: "Imagen", icon: ImageIcon },
  { type: "html", label: "HTML", icon: Code },
];

export default function BlockEditor({ value = [], onChange, testidPrefix = "block" }) {
  const blocks = value || [];
  const add = (type) => onChange([...blocks, { type, text: "", url: "" }]);
  const set = (i, patch) => onChange(blocks.map((b, idx) => (idx === i ? { ...b, ...patch } : b)));
  const remove = (i) => onChange(blocks.filter((_, idx) => idx !== i));
  const move = (i, d) => {
    const a = [...blocks]; const j = i + d;
    if (j < 0 || j >= a.length) return;
    [a[i], a[j]] = [a[j], a[i]]; onChange(a);
  };

  return (
    <div>
      <div className="flex flex-wrap gap-1 mb-2">
        {TYPES.map((t) => (
          <button key={t.type} type="button" onClick={() => add(t.type)}
            className="inline-flex items-center gap-1 text-xs border border-border rounded-sm px-2 py-1 hover:border-brand"
            data-testid={`${testidPrefix}-add-${t.type}`}>
            <t.icon className="h-3 w-3" /> {t.label}
          </button>
        ))}
      </div>
      {blocks.length === 0 && <p className="text-xs text-muted-foreground italic">Sin bloques. Añada uno con los botones de arriba.</p>}
      {blocks.map((b, i) => (
        <div key={i} className="border border-border rounded-sm p-2 mb-2 bg-white" data-testid={`${testidPrefix}-item-${i}`}>
          <div className="flex items-center justify-between mb-1">
            <span className="text-[10px] font-mono uppercase text-muted-foreground">{b.type}</span>
            <div className="flex items-center gap-2">
              <button type="button" onClick={() => move(i, -1)} title="Subir" className="hover:text-brand"><ArrowUp className="h-3.5 w-3.5" /></button>
              <button type="button" onClick={() => move(i, 1)} title="Bajar" className="hover:text-brand"><ArrowDown className="h-3.5 w-3.5" /></button>
              <button type="button" onClick={() => remove(i)} title="Eliminar" className="text-destructive"><Trash2 className="h-3.5 w-3.5" /></button>
            </div>
          </div>
          {b.type === "image" ? (
            <div className="space-y-1">
              <input placeholder="URL de imagen o suba un archivo" value={b.url || ""} onChange={(e) => set(i, { url: e.target.value })} className="w-full text-xs border border-border rounded-sm px-2 py-1" />
              <input placeholder="Texto alternativo (opcional)" value={b.text || ""} onChange={(e) => set(i, { text: e.target.value })} className="w-full text-xs border border-border rounded-sm px-2 py-1" />
              <label className="inline-block text-xs text-brand cursor-pointer hover:underline">
                Subir imagen desde el ordenador
                <input type="file" accept="image/*" className="hidden" data-testid={`${testidPrefix}-upload-${i}`}
                  onChange={async (e) => { const f = e.target.files[0]; if (f) { try { const url = await uploadImage(f); set(i, { url }); toast.success("Imagen subida"); } catch { toast.error("Error al subir"); } } }} />
              </label>
              {b.url && <img src={mediaUrl(b.url)} alt="" className="h-20 rounded-sm border border-border object-contain bg-secondary" />}
            </div>
          ) : b.type === "html" ? (
            <textarea placeholder="Código HTML" value={b.text || ""} onChange={(e) => set(i, { text: e.target.value })} rows={4} className="w-full text-xs border border-border rounded-sm px-2 py-1 font-mono" />
          ) : (
            <textarea placeholder={b.type === "heading" ? "Título del bloque" : "Texto del bloque"} value={b.text || ""} onChange={(e) => set(i, { text: e.target.value })} rows={b.type === "heading" ? 1 : 3} className="w-full text-xs border border-border rounded-sm px-2 py-1" />
          )}
        </div>
      ))}
    </div>
  );
}
